package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminOverviewInsightsResponse(
    @SerialName("total_teams") val totalTeams: Int,
    @SerialName("total_leagues") val totalLeagues: Int,
    @SerialName("total_players") val totalPlayers: Int,
    @SerialName("total_fixtures") val totalFixtures: Int,
    @SerialName("fixtures_by_status") val fixturesByStatus: Map<String, Int>,
    @SerialName("recent_syncs") val recentSyncs: List<AdminRecentSyncInfo>,
    @SerialName("last_sync_at_utc") val lastSyncAtUtc: String?,
    @SerialName("total_legacy_teams") val totalLegacyTeams: Int = 0,
    @SerialName("total_legacy_leagues") val totalLegacyLeagues: Int = 0,
    @SerialName("total_legacy_players") val totalLegacyPlayers: Int = 0,
)

@Serializable
data class AdminRecentSyncInfo(
    @SerialName("job_name") val jobName: String,
    val status: String,
    @SerialName("records_updated") val recordsUpdated: Int,
    @SerialName("finished_at_utc") val finishedAtUtc: String?,
)
